module.exports = __webpack_public_path__ + "static/media/coconut-filled-with-strawberry.9b1fcb30.jpg";